/**
 * @generated SignedSource<<ef9eb7abd2b9d11ba290574e342b8a56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type leadContactDialogContentFragment$data = {
  readonly email: string | null | undefined;
  readonly id: string;
  readonly phoneNumber: string | null | undefined;
  readonly " $fragmentType": "leadContactDialogContentFragment";
};
export type leadContactDialogContentFragment$key = {
  readonly " $data"?: leadContactDialogContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"leadContactDialogContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "leadContactDialogContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "LeadInterface",
  "abstractKey": "__isLeadInterface"
};

(node as any).hash = "1ca0929f77f28262fc0529a0130ef9b4";

export default node;
